import { render, staticRenderFns } from "./club-activity-data.vue?vue&type=template&id=2e54f404&scoped=true&"
import script from "./club-activity-data.vue?vue&type=script&lang=js&"
export * from "./club-activity-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54f404",
  null
  
)

export default component.exports